export default __webpack_public_path__ + "static/StreakOrig-ccd3f4ef68500b51c966d66c0364b25d.jpg";